import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/empty-comment.png'
import _imports_1 from '../assets/img/default-avater.png'
import _imports_2 from '../assets/img/new-zan-not.png'
import _imports_3 from '../assets/img/ic_activity_arrow.png'


const _withScopeId = n => (_pushScopeId("data-v-faecc632"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "null-box"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "comment-box"
}
const _hoisted_6 = { class: "header" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "avater",
  src: _imports_1,
  alt: ""
}
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = { class: "line-box" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hotlist-opera-zan",
  src: _imports_2
}, null, -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 1,
  class: "sub-wrap"
}
const _hoisted_17 = { class: "sub-comment" }
const _hoisted_18 = { class: "reply-box" }
const _hoisted_19 = { class: "reply-name first" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "rp-text" }, "回复", -1))
const _hoisted_21 = { class: "reply-name" }
const _hoisted_22 = {
  key: 0,
  class: "more-text"
}
const _hoisted_23 = {
  key: 0,
  class: "more-btn"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "查看更多评论", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]

import { ref, computed } from 'vue';
import { timeTransform, format } from '@/lib';
import ImgBox from '../components/ImgBox.vue';
interface EmitsType {
  (e: 'download'): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
  list: {
    type: Object,
    default: []
  },
  showCatchTips: {
    type: Boolean,
    default: false
  }
},
  emits: ["download"],
  setup(__props, { emit }: { emit: ({
  (e: 'download'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const showNull = ref(true);

const isNull = computed(() => props.list && props.list.length);

const download = () => {
  emit('download');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["comment-wrap", {'height-full': __props.showCatchTips}])
  }, [
    (!_unref(isNull))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          (__props.showCatchTips)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "动态跑去火星了~"))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, "成为第一个写评论的人 ~"))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "comment-item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_6, [
                (item.userInfo.userLogo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "avater",
                      src: item.userInfo.userLogo,
                      alt: ""
                    }, null, 8, _hoisted_7))
                  : (_openBlock(), _createElementBlock("img", _hoisted_8)),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", {
                    class: _normalizeClass(['name', !item.userInfo.userName && 'set-empty'])
                  }, _toDisplayString(item.userInfo.userName || '占位'), 3),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(timeTransform)(_unref(format)(item.createTime))), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  (item.commentLike)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(item.commentLike), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  class: "text-info",
                  innerHTML: item.content
                }, null, 8, _hoisted_15),
                (item.commentImages)
                  ? (_openBlock(), _createBlock(ImgBox, {
                      key: 0,
                      class: "img-list",
                      picUrl: item?.commentImages,
                      noPreview: true,
                      onDownload: download
                    }, null, 8, ["picUrl"]))
                  : _createCommentVNode("", true),
                (item.subComments)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("p", _hoisted_19, _toDisplayString(item.subComments[0].replyUserInfo.userName), 1),
                          _hoisted_20,
                          _createElementVNode("p", _hoisted_21, "@" + _toDisplayString(item.subComments[0].userInfo.userName), 1),
                          _createElementVNode("p", null, "：" + _toDisplayString(item.subComments[0].content), 1)
                        ]),
                        (item.subComments[0].commentImages)
                          ? (_openBlock(), _createBlock(ImgBox, {
                              key: 0,
                              class: "img-list",
                              picUrl: item.subComments[0].commentImages,
                              noPreview: true,
                              onDownload: download
                            }, null, 8, ["picUrl"]))
                          : _createCommentVNode("", true)
                      ]),
                      (item.subComments && item.subComments.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("p", null, "查看全部" + _toDisplayString(item.commentCount) + "条回复", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          (__props.list && __props.list.length >= 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
            : _createCommentVNode("", true)
        ]))
  ], 2))
}
}

})